const routes = [
  { path: '/', component: 'Home' },
  { path: '/all', component: 'AllResults' },
  { path: '/about', component: 'About' },
  { path: '/writing', component: 'Writing' },
  { path: '/works', component: 'Works' },
  { path: '/social', component: 'Social' },
  { path: '/projects', component: 'ProjectsPage' },
  { path: '/images', component: 'ImagesPage' },
  { path: '/blog', component: 'BlogPage' },
  { path: '/products/social_media_post_english_creator', component: 'EnglishAgent' },
  { path: '/personal_branding_agent', component: 'ProductLinkedin' },
  { path: '/products/email_map_scraper', component: 'MapScraper' },
  { path: '/google_maps_email_scraper', component: 'ProductMapScraper' },
  { path: '/sales_agent', component: 'ProductSalesAgent' },
  { path: '/socialmedia_agent', component: 'ProductLinkedin' },
  { path: '/legal_agent', component: 'ProductLegalAgent' },
  { path: '/realestate_agent', component: 'ProductRealEstateAgent' },
  { path: '/investor_agent', component: 'InvestAgent' },
  { path: '/hr_agent', component: 'HrAgent' },
  { path: '/shopping_agent', component: 'ProductShoppingAgent' },
  { path: '/shopify_agent', component: 'ProductShopifyAgent' },
];

export default routes;
